import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import type { BilingualContent } from '../../types';

interface BilingualTextareaProps {
  label: string;
  value: BilingualContent;
  onChange: (value: BilingualContent) => void;
  placeholder?: { en?: string; de?: string };
  rows?: number;
  required?: boolean;
}

const BilingualTextarea: React.FC<BilingualTextareaProps> = ({
  label,
  value,
  onChange,
  placeholder,
  rows = 3,
  required = false,
}) => {
  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-1">
        {label}
        {required && <span className="text-destructive">*</span>}
      </Label>
      <Textarea
        value={value.de}
        onChange={(e) => onChange({ ...value, de: e.target.value })}
        placeholder={placeholder?.de}
        rows={rows}
      />
    </div>
  );
};

export default BilingualTextarea;
